export default __webpack_public_path__ + "5c01ee16ae6b121852bb6e735d7eeec1.jpg";